import React, { useMemo, useState } from "react";
import {
  Grid, Paper, Typography, Box, Stack, TextField, Button, List, ListItemButton, Divider, Chip
} from "@mui/material";

function Card({ title, subtitle, children }) {
  return (
    <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: "1px solid var(--border)", bgcolor: "var(--branco)" }}>
      <Typography sx={{ fontWeight: 900, color: "var(--cise-text)" }}>{title}</Typography>
      {subtitle && <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13, mt: 0.3 }}>{subtitle}</Typography>}
      <Box sx={{ mt: 2 }}>{children}</Box>
    </Paper>
  );
}

const MOCK_TEMPLATES = [
  { id: "tmp1", name: "Abertura", category: "WhatsApp", text: "Oi! Tudo bem? 😊 Vi seu contato aqui na Cultura Inglesa. Me diz: você busca curso pra você ou pra alguém?" },
  { id: "tmp2", name: "Follow-up (sem resposta)", category: "WhatsApp", text: "Oi! Passando rapidinho pra ver se conseguiu ver minha mensagem 😊 Quer que eu te mande opções de horários?" },
  { id: "tmp3", name: "Agendamento", category: "WhatsApp", text: "Perfeito! Posso te sugerir dois horários pra aula/diagnóstico: amanhã 10h ou 14h. Qual fica melhor?" },
  { id: "tmp4", name: "Confirmação", category: "WhatsApp", text: "Combinado! ✅ Seu agendamento está confirmado. Qualquer coisa me chama por aqui." },
];

export default function TemplatesTab() {
  const [templates, setTemplates] = useState(MOCK_TEMPLATES);
  const [q, setQ] = useState("");
  const [selectedId, setSelectedId] = useState(templates[0]?.id);
  const [draft, setDraft] = useState(templates[0]?.text || "");

  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    if (!term) return templates;
    return templates.filter((t) => t.name.toLowerCase().includes(term) || t.text.toLowerCase().includes(term));
  }, [q, templates]);

  const selected = useMemo(() => templates.find((t) => t.id === selectedId), [templates, selectedId]);

  const onSelect = (t) => {
    setSelectedId(t.id);
    setDraft(t.text);
  };

  const save = () => {
    setTemplates((prev) => prev.map((t) => (t.id === selectedId ? { ...t, text: draft } : t)));
    alert("Template atualizado (mock).");
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <Card title="Biblioteca" subtitle="Templates e respostas rápidas">
          <TextField
            value={q}
            onChange={(e) => setQ(e.target.value)}
            size="small"
            fullWidth
            placeholder="Buscar templates..."
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 999, background: "var(--bg)" } }}
          />

          <Paper elevation={0} sx={{ mt: 2, border: "1px solid var(--border)", borderRadius: 2, overflow: "hidden" }}>
            <List sx={{ p: 0 }}>
              {filtered.map((t, idx) => {
                const active = t.id === selectedId;
                return (
                  <React.Fragment key={t.id}>
                    <ListItemButton
                      onClick={() => onSelect(t)}
                      sx={{
                        py: 1.4,
                        bgcolor: active ? "rgba(33,49,89,0.10)" : "transparent",
                        "&:hover": { bgcolor: active ? "rgba(33,49,89,0.12)" : "rgba(15,23,42,0.04)" },
                      }}
                    >
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                          <Typography sx={{ fontWeight: 900 }} noWrap>{t.name}</Typography>
                          <Chip label={t.category} size="small" sx={{ fontWeight: 900, border: "1px solid var(--border)", bgcolor: "var(--branco)" }} />
                        </Stack>
                        <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13 }} noWrap>
                          {t.text}
                        </Typography>
                      </Box>
                    </ListItemButton>
                    {idx !== filtered.length - 1 && <Divider />}
                  </React.Fragment>
                );
              })}
            </List>
          </Paper>

          <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
            <Button
              variant="outlined"
              sx={{ textTransform: "none", fontWeight: 900, borderColor: "var(--border)" }}
              onClick={() => alert("Novo template (futuro)")}
            >
              Novo template
            </Button>
          </Stack>
        </Card>
      </Grid>

      <Grid item xs={12} md={8}>
        <Card
          title={selected?.name ? `Editar: ${selected.name}` : "Editar template"}
          subtitle="Escreva no tom humano (WhatsApp), sem marketing institucional"
        >
          <TextField
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            fullWidth
            multiline
            minRows={10}
            placeholder="Texto do template..."
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, background: "var(--bg)" } }}
          />

          <Stack direction={{ xs: "column", md: "row" }} spacing={1} justifyContent="flex-end" sx={{ mt: 2 }}>
            <Button
              variant="outlined"
              sx={{ textTransform: "none", fontWeight: 900, borderColor: "var(--border)" }}
              onClick={() => setDraft(selected?.text || "")}
            >
              Descartar
            </Button>
            <Button
              variant="contained"
              sx={{ textTransform: "none", fontWeight: 900, bgcolor: "var(--cise-blue)", "&:hover": { bgcolor: "var(--cise-blue)" } }}
              onClick={save}
            >
              Salvar
            </Button>
          </Stack>
        </Card>
      </Grid>
    </Grid>
  );
}